const MS_PER_SEC = 1e3;
const NS_PER_MS = 1e6;
const US_PER_SEC = 1e6;
const NS_PER_US = 1e3;
export const now = (() => {
    if (typeof process != 'undefined' && process.hrtime) {
        return () => {
            const nowTuple = process.hrtime(); // Returns [seconds, nanoseconds]
            return nowTuple[0] * MS_PER_SEC + nowTuple[1] / NS_PER_MS;
        };
    }
    if (typeof performance != 'undefined' && performance.now) {
        return () => performance.now();
    }
    return () => Date.now();
})();
export const nowMicroSeconds = (() => {
    if (typeof process != 'undefined' && process.hrtime) {
        return () => {
            const nowTuple = process.hrtime(); // Returns [seconds, nanoseconds]
            return nowTuple[0] * US_PER_SEC + nowTuple[1] / NS_PER_US;
        };
    }
    if (typeof performance != 'undefined' && performance.now) {
        return () => Math.round(performance.now() * 1000);
    }
    // that basically means we don't have up to microseconds precision and left with milliseconds.
    // Not sure if there's any modern JS engine left that doesn't support performance.now
    return () => Date.now() * 1000;
})();
//# sourceMappingURL=now.js.map